import { render } from "./myTrainingPlan.vue?vue&type=template&id=72e828b2&scoped=true"
import script from "./myTrainingPlan?vue&type=script&lang=js"
export * from "./myTrainingPlan?vue&type=script&lang=js"

import "./myTrainingPlan.vue?vue&type=style&index=0&id=72e828b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e828b2"]])

export default __exports__